import React, { useEffect, useState } from "react";
import ImageUploading from "react-images-uploading";
import { useNavigation, useAuth } from "react-uicomp";
import { useForm } from "react-hook-form";
import Select from "react-select";

// MATERIAL
import { Button } from "@material-ui/core";

// ACTIONS
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  editResearchAction,
  getResearchDetailAction,
  getResearchProgramAction,
} from "../../../actions/Actions";

// HOCS
import CompWrapper from "../../hocs/CompWrapper.hoc";
import ActivityIndicator from "../../hocs/ActivityIndicator.hoc";

// COMMON
import { InputField } from "../../common/inputField/InputField.common";
import DotPulse from "../../common/dotPulse/DotPulse.common";

// HELPERS
import { isValid, validator } from "../../../utils/Validator.util";
import { FILE_URL } from "../../../config/Config";

const EditResearchPage = (props) => {
  const { navigation, params } = useNavigation();
  const { toast } = useAuth();
  const { navigate, routes } = navigation;
  const {
    editResearchAction,
    getResearchDetailAction,
    research,
    getResearchProgramAction,
    researchProgram,
  } = props;
  const { editLoader, detail } = research;
  const { listResearchPorgram } = researchProgram;
  const { handleSubmit, register } = useForm();

  const [image, setImage] = useState([]);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    getResearchDetailAction(Number(params.id));
  }, [getResearchDetailAction, params.id]);

  const onChange = (imageList) => {
    setImageError(false);
    setImage(imageList);
  };

  const [researchProgramOption, setResearchProgramOption] = useState([]);
  const [selectedResearchProgram, setSelectedResearchProgram] = useState([]);
  const [deletedResearchProgramList, setDeletedResearchProgramList] = useState(
    [],
  );

  const handleResearchProgram = (selectedOptions) => {
    setSelectedResearchProgram(selectedOptions);

    const olderResearchProgramValue = detail?.research_program?.map(
      (item, index) => {
        return {
          id: item.id,
          label: item.name.en,
          value: item.name.en,
        };
      },
    );

    const removedResearchProgramId = olderResearchProgramValue?.filter(
      (oldItem) =>
        !selectedOptions?.some((newItem) => newItem.id === oldItem.id),
    );

    setDeletedResearchProgramList((prevItems) => {
      if (removedResearchProgramId?.length > 0) {
        return [...prevItems, ...removedResearchProgramId];
      } else {
        return [...prevItems];
      }
    });
  };

  useEffect(() => {
    const defaultResearchProgramValue = detail?.research_program?.map(
      (item, index) => {
        return {
          id: item.id,
          label: item.name.en,
          value: item.name.en,
        };
      },
    );

    setSelectedResearchProgram(defaultResearchProgramValue);
  }, [detail]);

  useEffect(() => {
    const remappedResearchProgramList = listResearchPorgram?.map(
      (item, index) => {
        return {
          id: item.id,
          label: item.name.en,
          value: item.name.en,
        };
      },
    );
    setResearchProgramOption(remappedResearchProgramList);
  }, [listResearchPorgram]);

  useEffect(() => {
    getResearchProgramAction();
  }, [getResearchProgramAction]);

  const onSubmit = (data) => {
    const catchedErros = {};
    const validate = validator(catchedErros);

    validate(
      "selectedResearchProgram",

      selectedResearchProgram === undefined ||
        selectedResearchProgram === null ||
        selectedResearchProgram?.length === 0,
      () => {
        toast({
          message: "Please Choose at least one research program",
          type: "error",
        });
      },
    );

    if (!isValid(catchedErros)) {
      console.error(catchedErros);
      return;
    }

    const description = {
      title: {
        en: data.titleEng,
        np: data.titleNep,
      },
    };

    const body = {
      name: data.titleEng,
      description: JSON.stringify(description),
      addedResearch: selectedResearchProgram?.map((item, index) => item.id),
      deletedResearch: deletedResearchProgramList?.map(
        (item, index) => item.id,
      ),
    };

    const photoFormdata = new FormData();

    image.length > 0 && photoFormdata.append("imageFile", image[0].file);

    editResearchAction(
      Number(params.id),
      body,
      photoFormdata,
      goBackHandler,
      toast,
    );
  };

  const goBackHandler = () => {
    navigate(routes.Research.path);
  };

  return (
    <CompWrapper>
      {!detail ? (
        <DotPulse />
      ) : (
        <div className="addnews-container">
          <div className="addnews">
            <form className="addnews-form" onSubmit={handleSubmit(onSubmit)}>
              <div className="addnews-form-input">
                <div className="addnews-form-input-label">Title</div>

                <InputField
                  name="titleEng"
                  placeholder="Title"
                  innerRef={register({ required: true })}
                  defaultValue={JSON.parse(detail?.cat_description).title.en}
                />
              </div>

              <div className="addnews-form-input">
                <div className="addnews-form-input-label">शीर्षक</div>

                <InputField
                  name="titleNep"
                  placeholder="शीर्षक"
                  innerRef={register({ required: true })}
                  defaultValue={JSON.parse(detail?.cat_description).title.np}
                />
              </div>

              {detail.cat_image && image.length === 0 && (
                <div
                  style={{
                    position: "relative",
                    width: 200,
                    height: 200,
                    overflow: "hidden",
                  }}>
                  <img
                    src={FILE_URL + detail.cat_image}
                    alt=""
                    style={{
                      width: "100%",
                      objectFit: "cover",
                      overflow: "hidden",
                    }}
                  />
                </div>
              )}

              <ImageUploading
                value={image}
                onChange={onChange}
                multiple={false}>
                {({ imageList, onImageUpload, onImageRemove }) => (
                  <div className="upload__image-wrapper">
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat( auto-fill, minmax(200px, 1fr) )",
                        columnGap: 10,
                      }}>
                      {imageList.map((image, index) => (
                        <div
                          key={index}
                          style={{
                            position: "relative",
                            width: 200,
                            height: 200,
                            overflow: "hidden",
                          }}>
                          <img
                            src={image.dataURL}
                            alt=""
                            style={{
                              width: "100%",
                              objectFit: "cover",
                              overflow: "hidden",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                    <Button
                      className="fixedwidth"
                      onClick={onImageUpload}
                      variant="contained"
                      color="primary">
                      Change image
                    </Button>
                    {imageError && <div>Image Required</div>}
                  </div>
                )}
              </ImageUploading>

              <div className="addnews-form-input">
                <div className="addnews-form-input-label">Research Program</div>
                <Select
                  isMulti
                  options={researchProgramOption}
                  value={selectedResearchProgram}
                  onChange={handleResearchProgram}
                  placeholder="Select Research Program"
                />
              </div>

              <ActivityIndicator animating={editLoader}>
                <Button
                  className="fixedwidth"
                  variant="contained"
                  color="primary"
                  type="submit">
                  Submit
                </Button>
              </ActivityIndicator>
            </form>
          </div>
        </div>
      )}
    </CompWrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    research: state.research,
    researchProgram: state.researchProgram,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      editResearchAction,
      getResearchDetailAction,
      getResearchProgramAction,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(EditResearchPage);
